import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'

import { IoCarSportOutline, IoPersonOutline, IoDocumentTextOutline } from 'react-icons/io5'

const REGISTRIES = [
    { key: 'vehicles', label: 'Véhicules', icon: <IoCarSportOutline />, link: '/admin/floatTable' },
    { key: 'drivers', label: 'Chauffeurs', icon: <IoPersonOutline />, link: '/admin/responsableTable' },
    { key: 'documents', label: 'Documents', icon: <IoDocumentTextOutline />, link: '/admin/documentTable' },
]

function RegistryQueue({ data }) {
    const navigate = useNavigate()

  return (
    <Fragment>
        <div className='registryQueue'>
            {REGISTRIES.map(reg => {
                const counts = data?.[reg.key] || { nouveau: 0, valide: 0, annule: 0 }
                const total = counts.nouveau + counts.valide + counts.annule

                return (
                    <div className='registryCol' key={reg.key}>
                        <div className='registryHead'>
                            <span className='registryIcon'>{reg.icon}</span>
                            <span className='registryLabel'>{reg.label}</span>
                        </div>

                        {total === 0 ? (
                            <p className='emptyState'>Aucun enregistrement.</p>
                        ) : (
                            <Fragment>
                                <div className='registryPending'>
                                    <span className='pendingValue'>{counts.nouveau}</span>
                                    <span className='pendingLabel'>en attente de validation</span>
                                </div>

                                <div className='registryBar'>
                                    <div className='seg seg-nouveau' style={{ width: `${(counts.nouveau / total) * 100}%` }}></div>
                                    <div className='seg seg-valide' style={{ width: `${(counts.valide / total) * 100}%` }}></div>
                                    <div className='seg seg-annule' style={{ width: `${(counts.annule / total) * 100}%` }}></div>
                                </div>

                                <div className='registryLegend'>
                                    <span><i className='dot dot-valide'></i>{counts.valide} validés</span>
                                    <span><i className='dot dot-annule'></i>{counts.annule} annulés</span>
                                </div>

                                <button type='button' className='registryLink' onClick={() => navigate(reg.link)}>
                                    Voir le registre →
                                </button>
                            </Fragment>
                        )}
                    </div>
                )
            })}
        </div>
    </Fragment>
  )
}

export default RegistryQueue
